import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bank-card page-content" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "bank-list" }
const _hoisted_4 = { class: "bank-name" }
const _hoisted_5 = { class: "bank-card-number" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "add-btn" }

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import CustomTitleBar from '@/components/CustomTitleBar/index.vue'
import AddBankCard from './components/AddBankCard.vue'
import { showConfirmDialog, showToast } from 'vant'
import { getCardList, unbindCard } from '@/api/wallet'
// 路由实例

export default /*@__PURE__*/_defineComponent({
  __name: 'bankCard',
  setup(__props) {

const router = useRouter()

// 银行列表
const bankList = ref<any[]>()

// 控制弹出层显示
const isShowPopup = ref<boolean>(false)

// 显示添加银行卡弹层
const showAddCard = () => {
  isShowPopup.value = true
}

// 关闭弹层
const closePopup = () => {
  isShowPopup.value = false
  getList()
}

// 处理解绑银行卡
const handleUnbind = (card: any) => {
  showConfirmDialog({
    title: '提示',
    message: `确定要解绑${card.bankName}银行卡吗？`,
  })
    .then(() => {
      // TODO: 调用解绑接口
      unbindCard({ linkId: card.linkId }).then((res) => {
        if (res.code === 200) {
          showToast('解绑成功')
          getList()
        } else {
          showToast(res.msg)
        }
      })
    })
    .catch(() => {
      // 取消解绑
    })
}

// 获取银行卡列表
const getList = () => {
  getCardList().then((res) => {
    console.log('银行卡列表', res)
    if (res.code === 200) {
      bankList.value = res.data
    }
  })
}

onMounted(() => {
  getList()
})

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomTitleBar, { title: "银行卡" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "bank-item",
            key: item
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.bankName), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.bankAccountNo), 1),
            _createElementVNode("div", {
              class: "unbind-btn",
              onClick: ($event: any) => (handleUnbind(item))
            }, "解绑", 8, _hoisted_6)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_van_button, {
          plain: "",
          round: "",
          type: "primary",
          block: "",
          class: "custom-btn",
          onClick: showAddCard
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" 添加银行卡 ")
          ])),
          _: 1
        })
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tips" }, [
        _createElementVNode("span", null, "*说明：必须添加本人名下银行卡，一旦用户名绑定，将无法更改用户名。")
      ], -1))
    ]),
    _createVNode(_component_van_popup, {
      show: isShowPopup.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((isShowPopup).value = $event)),
      position: "bottom",
      round: "",
      style: { height: '100%' }
    }, {
      default: _withCtx(() => [
        _createVNode(AddBankCard, { onClose: closePopup })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})